import {z} from 'zod';

export const ReceiveNoteListBulkEditFormSchema = z.object({
  invoiceNumber: z.object({
    isInvoiceNumberEnabled: z.boolean(),
    invoiceNumber: z.string().nullish(),
  }),
  invoiceIssueDate: z.object({
    isInvoiceIssueDateEnabled: z.boolean(),
    invoiceIssueDate: z.date().nullish(),
  }),
  deliveryNoteNumber: z.object({
    isDeliveryNoteNumberEnabled: z.boolean(),
    deliveryNoteNumber: z.string().nullish(),
  }),
  deliveryNoteIssueDate: z.object({
    isDeliveryNoteIssueDateEnabled: z.boolean(),
    deliveryNoteIssueDate: z.date().nullish(),
  }),
});

export type ReceiveNoteListBulkEditForm = z.infer<typeof ReceiveNoteListBulkEditFormSchema>;
